import React from 'react';
import { Link } from 'react-router-dom';
import { LogEventBadge } from './logEventUtils';

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('id-ID', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

const formatJson = (value) => {
  if (value == null) return '-';
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

const ShowCpanelLogComp = ({ activity }) => {
  if (!activity) return null;

  return (
    <div className="cpanel-log-detail">
      <dl className="row mb-0">
        <dt className="col-sm-4 text-muted">Waktu</dt>
        <dd className="col-sm-8">{formatDate(activity.createdAt || activity.created_at)}</dd>

        <dt className="col-sm-4 text-muted">Event</dt>
        <dd className="col-sm-8">
          <LogEventBadge event={activity.event} />
        </dd>

        <dt className="col-sm-4 text-muted">Nama Log</dt>
        <dd className="col-sm-8">{activity.logName || activity.log_name || '-'}</dd>

        <dt className="col-sm-4 text-muted">Deskripsi</dt>
        <dd className="col-sm-8">{activity.description || '-'}</dd>

        <dt className="col-sm-4 text-muted">Pelaku</dt>
        <dd className="col-sm-8">{activity.causerName || 'Sistem'}</dd>

        <dt className="col-sm-4 text-muted">Tipe Subjek</dt>
        <dd className="col-sm-8">{activity.subjectType || activity.subject_type || '-'}</dd>

        <dt className="col-sm-4 text-muted">ID Subjek</dt>
        <dd className="col-sm-8 font-monospace">
          {activity.subjectId || activity.subject_id || '-'}
          {!activity.subjectId && !activity.subject_id && (activity.event === 'imported' || activity.event === 'exported') ? (
            <span className="d-block text-muted small fw-normal font-sans-serif mt-1">
              Operasi impor/ekspor tidak terikat satu entitas.
            </span>
          ) : null}
        </dd>

        <dt className="col-sm-4 text-muted">Tenant Slug</dt>
        <dd className="col-sm-8">
          {activity.tenantSlug || activity.tenant_slug ? (
            <span className="text-primary fw-semibold">
              {activity.tenantSlug || activity.tenant_slug}
            </span>
          ) : (
            '-'
          )}
        </dd>

        <dt className="col-sm-4 text-muted">Job Runner</dt>
        <dd className="col-sm-8">
          {activity.jobId ? (
            <Link to={`/cpanel/jobs/${activity.jobId}`} className="font-monospace">
              {activity.jobId}
            </Link>
          ) : (
            '-'
          )}
        </dd>

        <dt className="col-sm-4 text-muted">Properti</dt>
        <dd className="col-sm-8">
          <pre className="bg-light rounded p-3 mb-0 small" style={{ maxHeight: '240px', overflow: 'auto' }}>
            {formatJson(activity.properties)}
          </pre>
        </dd>
      </dl>
    </div>
  );
};

export default ShowCpanelLogComp;
